import axios from 'axios';
import auth from '../cognito-auth/cognitoAuth';
import { loggerService } from './LoggerService';

const baseURL = process.env.VUE_APP_COMMISSIONING_API_URL;

const CommissioningService = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

function getBackofficeJwt() {
  return auth.auth.getSignInUserSession().getIdToken().jwtToken;
}

function compactParams(params = {}) {
  return Object.keys(params).reduce((result, key) => {
    if (
      params[key] !== '' &&
      params[key] !== null &&
      params[key] !== undefined
    ) {
      result[key] = params[key];
    }
    return result;
  }, {});
}

function createRequestConfig(params) {
  if (!baseURL) {
    throw new Error('Missing VUE_APP_COMMISSIONING_API_URL.');
  }

  return {
    headers: {
      Authorization: `Bearer ${getBackofficeJwt()}`,
    },
    params: compactParams(params),
  };
}

export async function getCommissioningSummary() {
  try {
    const response = await CommissioningService.get(
      'commissioning/orders/summary',
      createRequestConfig()
    );
    return response.data;
  } catch (error) {
    loggerService.error(error);
    return null;
  }
}

export async function getCommissioningPipelineSummary(
  journey = '',
  journeyTypes = []
) {
  try {
    const response = await CommissioningService.get(
      'commissioning/orders/pipeline-summary',
      createRequestConfig({
        journey,
        journey_types: journeyTypes.join(','),
      })
    );
    return response.data;
  } catch (error) {
    loggerService.error(error);
    return null;
  }
}

export async function getCommissioningOrdersWithFilter(params) {
  try {
    const response = await CommissioningService.get(
      'commissioning/orders',
      createRequestConfig(params)
    );
    return response.data;
  } catch (error) {
    loggerService.error(error);
    return null;
  }
}

export async function getCommissioningOrderById(orderId) {
  try {
    const response = await CommissioningService.get(
      `commissioning/orders/get-by-id/${orderId}`,
      createRequestConfig()
    );
    return response.data;
  } catch (error) {
    loggerService.error(error);
    return null;
  }
}

export async function getBusinessValues(type, tags = '') {
  try {
    const response = await CommissioningService.get(
      'business-values',
      createRequestConfig({ type, tags })
    );
    return response.data;
  } catch (error) {
    loggerService.error(error);
    return null;
  }
}

export async function getCommissioningSummaryForDiagram() {
  // No dedicated commissioning diagram summary endpoint exists yet.
  return null;
}

export async function getCommissioningOrderDocumentsHistory(requestBody) {
  try {
    const response = await CommissioningService.post(
      'commissioning/orders/document-history',
      requestBody,
      createRequestConfig()
    );
    return response.data;
  } catch (error) {
    loggerService.error(error);
    return null;
  }
}

export async function resendCommissioningOrderDocument(requestBody) {
  const response = await CommissioningService.post(
    'commissioning/orders/resend-document',
    requestBody,
    createRequestConfig()
  );
  return response.data;
}

export async function getCommissioningOrderHistory(requestBody) {
  try {
    const response = await CommissioningService.post(
      'commissioning/orders/history',
      requestBody,
      createRequestConfig()
    );
    return response.data;
  } catch (error) {
    loggerService.error(error);
    return null;
  }
}

export async function addCommissioningOrderNote(requestObject, user) {
  try {
    const response = await CommissioningService.post(
      'commissioning/orders/add-note',
      {
        changed_by: user,
        event_origin: 'BACKOFFICE',
        field: 'addCommissioningNote',
        payload: requestObject,
      },
      createRequestConfig()
    );
    return response.data;
  } catch (error) {
    loggerService.error(error);
    return null;
  }
}

export async function updateCommissioningOrderStatus(requestObject, user) {
  try {
    const response = await CommissioningService.post(
      'commissioning/orders/update',
      {
        changed_by: user,
        event_origin: 'BACKOFFICE',
        field: 'updateCommissioningOrderStatus',
        payload: requestObject,
      },
      createRequestConfig()
    );
    return response.data;
  } catch (error) {
    loggerService.error(error);
    return null;
  }
}

export async function updateCommissioningTechnicalInspectionData(
  requestObject,
  user
) {
  try {
    const response = await CommissioningService.post(
      'commissioning/orders/update',
      {
        changed_by: user,
        event_origin: 'BACKOFFICE',
        field: 'updateCommissioningTechnicalInspectionData',
        payload: requestObject,
      },
      createRequestConfig()
    );
    return response.data;
  } catch (error) {
    loggerService.error(error);
    return null;
  }
}
